import React from "react";
import { MuiBox } from "../box/MuiBox";
import { InformationBoxWrapper } from "./InformationBox.style";
import { MuiTypography } from "../typography/MuiTypography";

interface InformationBoxProps {
  title: string;
  children?: React.ReactNode;
}

export const InformationBox: React.FC<InformationBoxProps> = ({
  title,
  children,
}) => {
  return (
    <InformationBoxWrapper className="info-box-wrapper">
      <MuiBox className="line" />
      <MuiBox className="full-width">
        <MuiTypography
          role="heading"
          aria-level={1}
          variant="h1Bold"
          className="text"
          component="h1"
        >
          {title}
        </MuiTypography>
        {children}
      </MuiBox>
    </InformationBoxWrapper>
  );
};
